import { defineService } from '@nzyme/ioc/Service.js';
import { createPromise } from '@nzyme/utils/createPromise.js';
import { markRaw, ref } from 'vue';
export const TaskQueue = defineService({
    name: 'TaskQueue',
    setup() {
        const queue = [];
        const pending = ref();
        return markRaw({
            run,
            waitForAll,
            pending,
        });
        /**
         * Enqueues a task to be executed in FIFO order.
         * @param task - The task to run
         * @returns A promise that resolves when the task has been executed
         */
        function run(task, ...args) {
            const item = createPromise();
            item.task = task;
            item.args = args;
            queue.push(item);
            void processNext();
            return item.promise;
        }
        /**
         * Waits for all enqueued tasks (including currently processing one) to complete.
         */
        async function waitForAll() {
            const tasks = queue.map(item => item.promise);
            if (pending.value) {
                tasks.unshift(pending.value);
            }
            await Promise.all(tasks);
        }
        async function processNext() {
            if (pending.value) {
                return;
            }
            const task = queue.shift();
            if (!task) {
                return;
            }
            pending.value = task.promise;
            try {
                const result = await task.task(...task.args);
                task.resolve(result);
            }
            catch (error) {
                task.reject(error);
            }
            finally {
                pending.value = undefined;
                void processNext();
            }
        }
    },
});
//# sourceMappingURL=TaskQueue.js.map